import { sendGTMEvent } from '@next/third-parties/google';
import { EXPERIMENT_EVENT_NAME } from '@data/surveyConfigs';
import { DOMAIN } from '@/utils/constants';
import Cookies from 'js-cookie';

export const setExperimentCookie = (value: string) => {
  const expiresAt = new Date();
  expiresAt.setMinutes(expiresAt.getMinutes() + 30);
  const currentExperimentCookie = Cookies.get('oviva_experiment');

  let experimentValues: string[] = [];
  if (currentExperimentCookie) {
    experimentValues = currentExperimentCookie.split('&');
  }

  if (!experimentValues.includes(value)) {
    experimentValues.push(value);
  }

  Cookies.set('oviva_experiment', experimentValues.join('&'), {
    expires: expiresAt,
    domain: '.' + DOMAIN,
    path: '/',
    secure: true,
  });
};

export const trackAndSetExperimentCookie = (experiment: any, result: any) => {
  sendGTMEvent({
    event: EXPERIMENT_EVENT_NAME,
    selectedVariant: result.name,
    experimentId: experiment.key,
  });

  // Prevent setting cookie for A/A experiments
  if (experiment.key === 'growthbook_qa') {
    return;
  }

  setExperimentCookie(result.name);
};
